// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nh1[data-v-40f57cbe] {\n  font-size: 20px;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
